export default Object.freeze({
  /**
   * Represents the type of booking.
   *
   * - `Block`: Indicates that the user is looking for a block booking,
   *    which spans multiple days or includes multiple bookings as a group.
   *
   * - `SingleDay`: Indicates that the user is looking for a booking
   *    that occurs on a single day only.
   *
   * These labels are used to identify the nature of the booking
   * being use within the application.
   */
  Block: 'block',
  SingleDay: 'single-day',
})
